import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

export interface ReminderToastItem {
  id: string;
  title?: string;
  subtitle?: string;
  description?: string;
  meta?: any;
  createdAt: number;
}

const initialState: ReminderToastItem[] = [];

export const reminderToastsSlice = createSlice({
  name: "reminderToasts",
  initialState,
  reducers: {
    addReminderToast: (state, action: PayloadAction<ReminderToastItem>) => {
      const existingIndex = state.findIndex((t) => t.id === action.payload.id);
      if (existingIndex !== -1) {
        state.splice(existingIndex, 1);
      }
      state.unshift(action.payload);
    },
    removeReminderToast: (state, action: PayloadAction<string>) => {
      const payload = action.payload;
      // allow removing by the toast id OR by the notification's reminder_id (or other reminder identifiers)
      return state.filter((t) => {
        const notifRemId =
          t?.meta?.raw?.notification?.additionalData?.reminder_id;
        const metaRemId = t?.meta?.reminderId || t?.meta?.reminder?.id;
        return (
          t.id !== payload && notifRemId !== payload && metaRemId !== payload
        );
      });
    },
    clearReminderToasts: () => {
      return [];
    },
  },
});

export const { addReminderToast, removeReminderToast, clearReminderToasts } =
  reminderToastsSlice.actions;

export const selectReminderToasts = (state: RootState) =>
  state.reminderToasts as ReminderToastItem[];

export default reminderToastsSlice.reducer;
